import {
  GETUPDATECOMMOMCONFDETAILS_SUCCESS,
  GETUPDATECOMMOMCONFDETAILS_FAILED,
  RESET_GETUPDATECOMMOMCONFDETAILS,
  LOADING_GETUPDATECOMMOMCONFDETAILS,
  NETWORK_ERROR_GETUPDATECOMMOMCONFDETAILS,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetupdateCommonCfgDetails = () => {
  return { type: RESET_GETUPDATECOMMOMCONFDETAILS };
};

const updateCfgDetailsReqList = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETUPDATECOMMOMCONFDETAILS });
  await partnerServices
    .post("getUpdateCommomConfDetails", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "Success":
          dispatch(getCommonCfgsuccess(res.data));
          break;
        default:
          dispatch(getCommonCfgFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({
        type: NETWORK_ERROR_GETUPDATECOMMOMCONFDETAILS,
        payload: err,
      });
    });
};
function getCommonCfgsuccess(data) {
  return {
    type: GETUPDATECOMMOMCONFDETAILS_SUCCESS,
    payload: data,
  };
}
function getCommonCfgFailed(data) {
  return {
    type: GETUPDATECOMMOMCONFDETAILS_FAILED,
    payload: data,
  };
}

export { resetupdateCommonCfgDetails, updateCfgDetailsReqList };
